<template>
	<div>
		<el-card class="box-card1">
			<div slot="header" class="clearfix">
				<span>基础信息</span>
			</div>
			<el-form style="width: 70%;margin: 0 auto;" ref="form" :model="form1" label-width="100px">
				<el-form-item label="用户账号">
					<el-input v-model="form1.account"></el-input>
				</el-form-item>
				<el-form-item label="用户姓名">
					<el-input v-model="form1.name"></el-input>
				</el-form-item>
				<el-form-item label="状态">
					<el-select v-model="form1.status" placeholder="" style="width: 100%;">
						<el-option label="可用" value="1"></el-option>
						<el-option label="停用" value="0"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card class="box-card2">
			<div slot="header" class="clearfix">
				<span>修改密码</span>
			</div>
			<el-form style="width: 70%;margin: 0 auto;" ref="form" :model="form2" label-width="100px">
				<el-form-item label="新密码">
					<el-input v-model="form2.password"></el-input>
				</el-form-item>
				<el-form-item label="确认新密码">
					<el-input v-model="form2.password1"></el-input>
				</el-form-item>
			</el-form>
		</el-card>
		<div style="margin-top: 2.5rem">
			<el-button type="primary" @click="onSubmit" style="width: 6.25rem;height: 2.8125rem;margin-right: 1.25rem;">保存</el-button>
			<el-button style="width: 6.25rem;height: 2.8125rem;" @click="back">取消</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'edituser',
		props: ['userInfo'],
		data() {
			return {
				form1:{
					account:this.userInfo.loginName,
					name:this.userInfo.realName, 
					status:this.userInfo.status
				},
				
				form2: {
					password:'',
					password1:''
				}
			}

		},
		
		created() {
			console.log('edituser created form1 = ', this.form1)
		},

		methods: {
			onSubmit() {
				console.log('edituser onSubmit form1 = ', this.form1)
				console.log('edituser onSubmit form2 = ', this.form2)
				
				if (this.form2.password !== this.form2.password1) {
					this.$message.error('两个密码不一致！')
					return
				}
				
				this.$emit('editSave', this.form1, this.form2.password)
				
			},
			
			back() {
				console.log('edituser back')
				this.$emit('editBack')
			}
		}
	}
</script>

<style scoped="scoped">
	.clearfix {
		display: flex;
		justify-content: flex-start;
	}

	.box-card1,
	.box-card2 {
		height: 16.875rem;
		width: 80%;
		margin: 0 auto;
	}

	.box-card2 {
		height: 12.8125rem;
		margin-top: 1.25rem;
	}
	
</style>
